// TODA conversión de tiempo vive en este archivo (lección pagada: Sonora es UTC−7 todo el año, sin horario de verano).
// Nada en el cotizador usa new Date().toISOString().slice(0, 10) para "hoy": eso da la fecha de UTC y a partir de las
// 17:00 de Hermosillo ya es "mañana".

export const ZONA_HORARIA = 'America/Hermosillo';

const formatoFecha = new Intl.DateTimeFormat('en-CA', {
  timeZone: ZONA_HORARIA,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/** Fecha de Hermosillo en formato AAAA-MM-DD. */
export function fechaHermosillo(instante: Date = new Date()): string {
  if (Number.isNaN(instante.getTime())) throw new Error('fechaHermosillo: fecha inválida');
  return formatoFecha.format(instante);
}

/** Instante en ISO 8601 con zona (UTC). Para guardar: se guarda el instante, se muestra en Hermosillo. */
export function ahoraIso(instante: Date = new Date()): string {
  if (Number.isNaN(instante.getTime())) throw new Error('ahoraIso: fecha inválida');
  return instante.toISOString();
}

/** "2026-10" de Hermosillo (para el gasto mensual de la IA). */
export function anioMesHermosillo(instante: Date = new Date()): string {
  return fechaHermosillo(instante).slice(0, 7);
}

/** El instante (ISO, UTC) en que EMPIEZA un día de Hermosillo: "2026-10-12" → "2026-10-12T07:00:00.000Z" (UTC−7 todo el
 *  año). Se COMPRUEBA con fechaHermosillo en vez de suponerlo: si la zona cambiara algún día, truena aquí (fallo ruidoso)
 *  en vez de cortar los filtros por fecha una hora de más o de menos. Sirve para filtrar por fecha sobre un instante. */
export function inicioDiaHermosillo(fecha: string): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha)) throw new Error(`inicioDiaHermosillo: "${fecha}" no es AAAA-MM-DD`);
  const inicio = new Date(`${fecha}T07:00:00.000Z`);
  if (Number.isNaN(inicio.getTime()) || fechaHermosillo(inicio) !== fecha || fechaHermosillo(new Date(inicio.getTime() - 1)) === fecha)
    throw new Error(`inicioDiaHermosillo: el día ${fecha} de Hermosillo no empieza a las 07:00 UTC (¿cambió la zona horaria?)`);
  return inicio.toISOString();
}

/** Suma días a una fecha AAAA-MM-DD (calendario, sin zona: la fecha ya es de Hermosillo). */
export function sumarDias(fecha: string, dias: number): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(fecha);
  if (!m) throw new Error(`sumarDias: "${fecha}" no es AAAA-MM-DD`);
  if (!Number.isInteger(dias)) throw new Error('sumarDias: los días deben ser enteros');
  const d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  d.setUTCDate(d.getUTCDate() + dias);
  return d.toISOString().slice(0, 10);
}

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

/** "9 de octubre de 2026" (solo minúscula; nunca text-transform: capitalize con fechas en español). */
export function fechaLarga(fecha: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(fecha);
  if (!m) throw new Error(`fechaLarga: "${fecha}" no es AAAA-MM-DD`);
  return `${Number(m[3])} de ${MESES[Number(m[2]) - 1]} de ${m[1]}`;
}

/** Fecha y hora de un instante ISO, mostrada en Hermosillo: "9 oct 2026, 14:05". */
export function fechaHoraCorta(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) throw new Error(`fechaHoraCorta: "${iso}" no es una fecha`);
  const f = new Intl.DateTimeFormat('es-MX', {
    timeZone: ZONA_HORARIA, day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(d);
  const v = (t: string) => f.find((p) => p.type === t)?.value ?? '';
  return `${v('day')} ${v('month').replace('.', '')} ${v('year')}, ${v('hour')}:${v('minute')}`;
}
